/**
 * Bundle Promo Guard
 * --------------------
 * Whenever the cart drops below the configured minimum item count, this script
 * removes the bundle discount code from the cart by POSTing
 * `/cart/update.js` with `{ discount: '' }` — an undocumented but working
 * field on Shopify's Ajax cart API that clears ALL attached discount codes.
 *
 * This was verified live: a single call removes the code without touching
 * line items, properties, or selling plans, and Shopify recalculates totals.
 *
 * Configuration is read from window.BUNDLE_GUARD which is set in theme.liquid
 * from theme settings (Bundle promo guard section).
 */
(function () {
  var cfg = window.BUNDLE_GUARD || {};
  if (!cfg.code || !cfg.minItems) {
    console.warn('[bundle-guard] disabled — window.BUNDLE_GUARD not configured');
    return;
  }

  var DISCOUNT_CODE = String(cfg.code).trim().toLowerCase();
  var MIN_ITEMS     = parseInt(cfg.minItems, 10) || 0;
  var enforcing     = false;

  function cartHasOurCode(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return false;
    return cart.discount_codes.some(function (d) {
      return d && d.code && d.code.toLowerCase() === DISCOUNT_CODE;
    });
  }

  function refreshCartSections() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
            oldDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
            var overlay = oldDrawer.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', oldDrawer.close.bind(oldDrawer));
          }
        }
        if (sections['cart-icon-bubble']) {
          var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bdoc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }
      });
  }

  function clearDiscountCookie() {
    // Shopify stores the active discount in a `discount_code` cookie that the
    // checkout reads to re-apply the code. Clearing it from the cart object
    // alone is not enough — we must wipe the cookie too, otherwise the code
    // reappears the moment the customer hits /checkout.
    var expired = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'discount_code=' + expired;
    document.cookie = 'discount_code=' + expired + '; domain=' + location.hostname;
    var rootDomain = location.hostname.split('.').slice(-2).join('.');
    if (rootDomain && rootDomain !== location.hostname) {
      document.cookie = 'discount_code=' + expired + '; domain=.' + rootDomain;
    }
  }

  function clearDiscountCode() {
    enforcing = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function () { clearDiscountCookie(); })
      .then(function () { return refreshCartSections(); })
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-guard' });
        }
      })
      .catch(function (err) {
        console.error('[bundle-guard] failed to clear discount:', err);
      })
      .finally(function () {
        enforcing = false;
      });
  }

  function checkAndEnforce() {
    if (enforcing) return;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cartHasOurCode(cart)) return;
        if (cart.item_count >= MIN_ITEMS) return;
        return clearDiscountCode();
      })
      .catch(function (err) {
        console.error('[bundle-guard] check failed:', err);
      });
  }

  function attach() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'bundle-guard') return;
        checkAndEnforce();
      });
    }
    // Sanity check on page load
    checkAndEnforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
